import styled from 'styled-components';
import Button from '../../../../core-components/Button/Button';
import {textSizes} from '@stencil/build-theme';

export const Container = styled.div`
  padding: 10px;
  width: 100%;
`;

export const BorderLine = styled.div`
  border-top: 1px solid ${props => props.theme.colors.shadow.base};
  margin-bottom: 1.5rem;
`;

export const ButtonWrapper = styled(Button)`
  width: 100%;
  margin: 0;
  font-size: ${props => props.theme.font.custom(16)};
`;

export const Description = styled.div`
  font-size: ${props => props.theme.font.custom(15)};
  color: ${props => props.theme.colors.black.base};
  margin-bottom: 10px;
`;

export const CheckAvailabilityBtn = styled(Button)`
  ${textSizes.MediumW1};
  padding: 1rem 2rem;
  margin: 0.5rem 0 0 0;
  background-color: ${props => props.theme.colors.goBrandBlue.base};
`;
